import styled from "@emotion/styled";
import { DialogTitle, Typography } from "@mui/material";

const TestResult = ({ calificacion }) => {
  return (
    <>
      <StyledDialogTitle component="div">
        <Typography variant="title" color="primary">
          {calificacion.aprobado ? "¡Felicidades!" : "Lo sentimos"}
        </Typography>
        <div>
          <Typography variant="subtitle" fontWeight={700} color="primary">
            {calificacion.aprobado
              ? "Felicitaciones has completado el módulo satisfactoriamente"
              : "Lo sentimos, no has contestado correctamente las preguntas"}
          </Typography>
          <br />
          <Typography variant="subtitle" fontWeight={700}>
            PUNTAJE: {calificacion.exitosas}/{calificacion.configuradas}
          </Typography>
        </div>
      </StyledDialogTitle>
    </>
  );
};

const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  > div {
    display: flex;
    flex-direction: column;
  }
  text-align: center;
`;
export default TestResult;
